import React from 'react';
import PropTypes from 'prop-types';
import graphql from "babel-plugin-relay/macro";
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import {useFragment} from "react-relay";
import {useUser} from "../../../hooks/useUser";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import NewFacilityLocationLanguageModal from "./NewFacilityLocationLanguageModal";
import EditFacilityLocationLanguageModal from "./EditFacilityLocationLanguageModal";
import DeleteModal from "../../../components/common/modals/DeleteModal";
import {useTableModals} from "../../../hooks/useTableModals";

const cols = [
    {accessor: 'language.name', Header: 'Language'},
    {accessor: 'seq', Header: 'Order'},
    {accessor: 'effectiveFrom', Header: "Effective From", Cell: DateCell},
    {accessor:'effectiveTo', Header:'Effective To', Cell: DateCell}
]
const FacilityLocationLanguages = ({facilityLocationId, languages, allLanguages}) => {
    const deleteMutation = graphql`
    mutation FacilityLocationLanguagesDeleteMutation($id: ID!) {
        deleteNode(input: {id: $id}) {
            deletedNodeId @deleteRecord
            owner {
                ... on FacilityLocation {
                    id
                    languages {
                        id
                    }}}}}`
    const data = useFragment(graphql`
        fragment FacilityLocationLanguages_Languages on FacilityLocationLanguage @relay(plural:true) {
            id
            language {
                id
                name
                isoCode
                displayOrder
            }
            seq
            effectiveFrom
            effectiveTo
        }
    `,languages)
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(cols, "FacilityLocation.Update", "FacilityLocation.Update");
    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Languages"}
                                         table
                                         showNew={hasPermission("FacilityLocation.Update")} />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewFacilityLocationLanguageModal showModal={newModal.showModal}
                                              onClose={newModal.onClose}
                                              languages={allLanguages}
                                              facilityLocationId={facilityLocationId}
            />
            {selected && <EditFacilityLocationLanguageModal showModal={editModal.showModal}
                                                            onClose={editModal.onClose}
                                                            selectedLanguage={selected}
                                                            languages={allLanguages}
            />}
            {selected && <DeleteModal mutation={deleteMutation}
                                      onClose={deleteModal.onClose}
                                      thingToDelete={"Language"}
                                      showModal={deleteModal.showModal}
                                      id={selected.id}
            >
                <p>This cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
FacilityLocationLanguages.propTypes = {
    facilityLocationId: PropTypes.string.isRequired,
    allLanguages: PropTypes.array.isRequired,
    languages: PropTypes.array.isRequired
}
export default FacilityLocationLanguages